import React from 'react';
import PropTypes from 'prop-types';

import MediaQuery, { breakpoints } from 'utils/media-query';
import { trackV2 } from 'utils/analytics';
import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import { checkoutUrl } from '../../helpers.js';
import styles from './index.scss';
import logo from './assets/wordmark-summit.svg';

const handleContinueClick = () => {
  trackV2({
    category: 'summit_upsell',
    page: 'checkout',
    action: 'continue_to_billing'
  });
};

const Banner = ({ option, trialInfo }) => {
  const baseClassName = trialInfo
    ? `${styles.banner} ${styles.trial}`
    : styles.banner;

  return (
    <div className={baseClassName}>
      <div className={`${styles.container} container`}>
        <div className={styles.branding}>
          <div className="branding logo-wh logo-xs">
            <span className="sr-only">Strava</span>
          </div>
        </div>
        <img className={styles.wordmark} src={logo} alt="SUMMIT" />
        <p className={styles.description}>
          {(() => {
            if (trialInfo) {
              return I18n.t(
                'strava.premium.package_select.banner.description_v3',
                { days: trialInfo.trialLength }
              );
            }

            return I18n.t(
              'strava.premium.package_select.banner.description_v4',
              {
                amount: Cldr.formatCurrency(
                  option.priceWithDiscount,
                  option.currency
                )
              }
            );
          })()}
        </p>
        {trialInfo && (
          <MediaQuery minWidth={breakpoints.screenXs}>
            <a
              href={checkoutUrl(option.packageIds, trialInfo)}
              className="btn btn-primary"
              onClick={handleContinueClick()}
              data-test="banner-trial-cta"
            >
              {I18n.t('strava.premium.package_select.banner.cta_trial', {
                days: trialInfo.trialLength
              })}
            </a>
          </MediaQuery>
        )}
      </div>
    </div>
  );
};

Banner.defaultProps = {
  trialInfo: null
};

Banner.propTypes = {
  option: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    priceWithDiscount: PropTypes.number.isRequired,
    packageIds: PropTypes.arrayOf(PropTypes.number).isRequired
  }).isRequired,
  trialInfo: PropTypes.shape({
    trialLength: PropTypes.number
  })
};

export default Banner;
